import {  useLocation } from "react-router-dom";
import { siderBar,account } from "../constants/sidebar";
import useProfile from "../controllers/useProfile";
import Account from '../context/acount';
export default function Dashboard(){
    const {pathname}=useLocation();
    const data=useProfile();
 
   return (
   <Account.Provider value={data}>
     <div className="w-[100%] h-[100vh]" >
      {
       siderBar.filter((el)=>el.path===pathname).map((el)=><div key={el.label} className="w-[100%]">{el.element}</div>)
      }
      {
        pathname===account.path &&  <div key={account.label} className="w-[100%]">{account.element}</div>
      }
    </div>
   </Account.Provider>
   )
}